import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header/header1";
import bannerImg from "../../images/robotics-for-good/banner.png";
import { withTranslation } from "react-i18next";

import robotics2026_1 from "../../images/robotics-for-good/robotics2026Introduction_1.jpg"
import robotics2026_2 from "../../images/robotics-for-good/robotics2026Introduction_2.jpg"
import robotics2026_3 from "../../images/robotics-for-good/robotics2026Introduction_3.jpg"
import robotics2026_4 from "../../images/robotics-for-good/robotics2026Introduction_4.jpg"
import robotics2026_5 from "../../images/robotics-for-good/robotics2026Introduction_5.jpg"
import robotics2026_6 from "../../images/robotics-for-good/robotics2026Introduction_6.jpg"

class RoboticsForGoodIntroduction extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {};
  }

  componentDidMount() { }

  robotics2025Content() {
    const { t } = this.props;
    return (
      <>
        {/* 🌍 Robotics for Good Youth Challenge Section */}
        < div className="section-full content-inner bg-white m-t30" >
          <div className="container">
            <div className="section-head style-1 text-center">
              <h2 className="title">
                {t("Robotics_For_Good_2025_Introduction_H")}
              </h2>
              <p>
                {t("Robotics_For_Good_2025_Introduction_Content_P1")}
              </p>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2025_Introduction_P2")}</h4>
                <p>
                  {t("Robotics_For_Good_2025_Introduction_Content_P2_1")}
                  <strong>{t("Robotics_For_Good_2025_Introduction_Content_P2_2")}</strong>
                  {t("Robotics_For_Good_2025_Introduction_Content_P2_3")}
                </p>
                <p>
                  {t("Robotics_For_Good_2025_Introduction_Content_P3_1")}
                  <strong>{t("Robotics_For_Good_2025_Introduction_Content_P3_2")}</strong>
                  {t("Robotics_For_Good_2025_Introduction_Content_P3_3")}
                  <strong>{t("Robotics_For_Good_2025_Introduction_Content_P3_4")}</strong>
                  {t("Robotics_For_Good_2025_Introduction_Content_P3_5")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  robotics2026Content() {
    const { t } = this.props;
    return (
      <>
        {/* 🌍 Robotics for Good Youth Challenge Section */}
        <div className="section-full content-inner bg-white m-t30" >
          <div className="container">
            <div className="section-head style-1 text-center">
              <h2 className="title">
                {t("Robotics_For_Good_2026_Introduction_H")}
              </h2>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Introduction_Content_P1_H")}</h4>

                <p>
                  {t("Robotics_For_Good_2026_Introduction_Content_P1_1")}
                  <strong>{t("Robotics_For_Good_2026_Introduction_Content_P1_2")}</strong>
                  {t("Robotics_For_Good_2026_Introduction_Content_P1_3")}
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Introduction_Content_P1_4")}
                  <strong>{t("Robotics_For_Good_2026_Introduction_Content_P1_5")}</strong>
                  {t("Robotics_For_Good_2026_Introduction_Content_P1_6")}
                  <strong>{t("Robotics_For_Good_2026_Introduction_Content_P1_7")}</strong>
                  {t("Robotics_For_Good_2026_Introduction_Content_P1_8")}
                </p>

                <p>
                  <strong>{t("Robotics_For_Good_2026_Introduction_Content_P1_9")}</strong>
                </p>

                {/* Video 1 */}
                <div style={{ textAlign: "center", margin: "11px 0" }}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      paddingBottom: "56.25%",
                      height: 0,
                      overflow: "hidden",
                    }}
                  >
                    <iframe
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        border: 0,
                      }}
                      title={t("Robotics_For_Good_2026_Introduction_Content_P1_VID_1")}
                      src="https://youtube.com/embed/1RP7vAY94Kk?si=dsi_JhTZKYHfCURR"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Introduction_Content_P2_H")}</h4>

                <div>
                  <h5>{t("Robotics_For_Good_2026_Introduction_Content_P2_1")}</h5>
                  <p>
                    {t("Robotics_For_Good_2026_Introduction_Content_P2_2")}
                    <strong>{t("Robotics_For_Good_2026_Introduction_Content_P2_3")}</strong>
                    {t("Robotics_For_Good_2026_Introduction_Content_P2_4")}
                  </p>

                  {/* IMG 1 & IMG 2*/}
                  <div style={{ textAlign: "center", margin: "11px 0" }}>
                    <div style={{ display: "flex", justifyContent: "center", gap: 5, flexWrap: "wrap" }}>
                      <img
                        src={robotics2026_1}
                        alt={t("Robotics_For_Good_2026_Introduction_IMG1_DESC")}
                        style={{ maxWidth: "45%", height: "auto" }}
                      />
                      <img
                        src={robotics2026_2}
                        alt={t("Robotics_For_Good_2026_Introduction_IMG2_DESC")}
                        style={{ maxWidth: "45%", height: "auto" }}

                      />
                    </div>

                    <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                      {t("Robotics_For_Good_2026_Introduction_IMG1_DESC")}
                    </div>
                    <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                      {t("Robotics_For_Good_2026_Introduction_IMG2_DESC")}
                    </div>
                  </div>
                </div>

                <div>
                  <h5>{t("Robotics_For_Good_2026_Introduction_Content_P3_1")}</h5>
                  <p>
                    {t("Robotics_For_Good_2026_Introduction_Content_P3_2")}
                    <strong>{t("Robotics_For_Good_2026_Introduction_Content_P3_3")}</strong>
                    {t("Robotics_For_Good_2026_Introduction_Content_P3_4")}
                    <strong>{t("Robotics_For_Good_2026_Introduction_Content_P3_5")}</strong>
                    {t("Robotics_For_Good_2026_Introduction_Content_P3_6")}
                  </p>

                  <p>
                    {t("Robotics_For_Good_2026_Introduction_Content_P3_7")}
                    <strong>{t("Robotics_For_Good_2026_Introduction_Content_P3_8")}</strong>
                    {t("Robotics_For_Good_2026_Introduction_Content_P3_9")}
                  </p>

                  <p>
                    <strong>{t("Robotics_For_Good_2026_Introduction_Content_P3_10")}</strong>
                  </p>

                  {/* Video 2 */}
                  <div style={{ textAlign: "center", margin: "11px 0" }}>
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        paddingBottom: "56.25%",
                        height: 0,
                        overflow: "hidden",
                      }}
                    >
                      <iframe
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          border: 0,
                        }}
                        title={t("Robotics_For_Good_2026_Introduction_Content_P3_VID_2")}
                        src="https://youtube.com/embed/GCtYFHzJIfo?si=5oQ3VLgSLuUJbke-"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>

                <div>
                  <h5>{t("Robotics_For_Good_2026_Introduction_Content_P4_1")}</h5>
                  <p>
                    {t("Robotics_For_Good_2026_Introduction_Content_P4_2")}
                  </p>

                  <p>
                    {t("Robotics_For_Good_2026_Introduction_Content_P4_3")}
                  </p>

                  {/* IMG 3 */}
                  <div style={{ textAlign: "center", margin: "11px 0" }}>
                    <img
                      src={robotics2026_3}
                      alt={t("Robotics_For_Good_2026_Introduction_IMG3_DESC")}
                    />
                    <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                      {t("Robotics_For_Good_2026_Introduction_IMG3_DESC")}
                    </div>
                  </div>
                </div>

                <div>
                  <h5>{t("Robotics_For_Good_2026_Introduction_Content_P5_1")}</h5>
                  <p>
                    {t("Robotics_For_Good_2026_Introduction_Content_P5_2")}
                  </p>

                  <p>
                    {t("Robotics_For_Good_2026_Introduction_Content_P5_3")}
                  </p>

                  <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                    <li>{t("Robotics_For_Good_2026_Introduction_Content_P5_4")}</li>
                    <li>{t("Robotics_For_Good_2026_Introduction_Content_P5_5")}</li>
                    <li>{t("Robotics_For_Good_2026_Introduction_Content_P5_6")}</li>
                    <li>{t("Robotics_For_Good_2026_Introduction_Content_P5_7")}</li>
                    <li>{t("Robotics_For_Good_2026_Introduction_Content_P5_8")}</li>
                    <li>{t("Robotics_For_Good_2026_Introduction_Content_P5_9")}</li>
                  </ul>

                  <p>
                    <strong>{t("Robotics_For_Good_2026_Introduction_Content_P5_10")}</strong>
                  </p>

                  {/* Video 3 */}
                  <div style={{ textAlign: "center", margin: "11px 0" }}>
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        paddingBottom: "56.25%",
                        height: 0,
                        overflow: "hidden",
                      }}
                    >
                      <iframe
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          border: 0,
                        }}
                        title={t("Robotics_For_Good_2026_Introduction_Content_P5_VID_3")}
                        src="https://youtube.com/embed/4p2QlfnuDEc?si=DNG9Zoy3kbKK2wG7"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>

                <div>
                  <h5>{t("Robotics_For_Good_2026_Introduction_Content_P6_1")}</h5>
                  <p>
                    {t("Robotics_For_Good_2026_Introduction_Content_P6_2")}
                  </p>

                  <p>
                    {t("Robotics_For_Good_2026_Introduction_Content_P6_3")}
                  </p>

                  <p>
                    <strong>{t("Robotics_For_Good_2026_Introduction_Content_P5_10")}</strong>
                  </p>

                  {/* IMG 4 & IMG 5*/}
                  <div style={{ textAlign: "center", margin: "11px 0" }}>
                    <div style={{ display: "flex", justifyContent: "center", gap: 5, flexWrap: "wrap" }}>
                      <img
                        src={robotics2026_4}
                        alt={t("Robotics_For_Good_2026_Introduction_IMG4_DESC")}
                        style={{ maxWidth: "60%", height: "auto" }}
                      />
                      <img
                        src={robotics2026_5}
                        alt={t("Robotics_For_Good_2026_Introduction_IMG4_DESC")}
                        style={{ maxWidth: "35%", height: "auto" }}

                      />
                    </div>

                    <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                      {t("Robotics_For_Good_2026_Introduction_IMG4_DESC")}
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Introduction_Content_P7_1")}</h4>

                {/* IMG 6 */}
                <div style={{ textAlign: "center", margin: "11px 0" }}>
                  <img
                    src={robotics2026_6}
                    alt={t("Robotics_For_Good_2026_Introduction_IMG6_DESC")}
                  />
                  <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                    {t("Robotics_For_Good_2026_Introduction_IMG6_DESC")}
                  </div>
                </div>

                <p>
                  {t("Robotics_For_Good_2026_Introduction_Content_P7_2")}
                  <strong>{t("Robotics_For_Good_2026_Introduction_Content_P7_3")}</strong>
                  {t("Robotics_For_Good_2026_Introduction_Content_P7_4")}
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Introduction_Content_P7_5")}
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Introduction_Content_P7_6")}
                </p>

                <p>
                  <strong>{t("Robotics_For_Good_2026_Introduction_Content_P7_7")}</strong>
                  <a href="/robotics-for-good/2026/application"><strong> Application Page</strong></a>
                </p>

                <p>
                  <strong>{t("Robotics_For_Good_2026_Introduction_Content_P7_8")}</strong>
                  <a href="mailto:contact@aaio.com.au"><strong> contact@aaio.com.au</strong></a>
                </p>
              </div>
            </div>


          </div>
        </div>
      </>
    )
  }

  render() {
    const { t } = this.props;

    const { year } = this.props.match.params;

    return (
      <>
        <Header />
        <div className="page-content">
          <div className="content-block" id="content-area">
            <div
              className="page-banner"
              style={{ backgroundImage: `url(${bannerImg})` }}
            >
              <div className="container">
                <div className="page-banner-entry">
                  <h1 className="text-white">
                    {t("Robotics_For_Good_Introduction_Title")}
                  </h1>
                </div>
              </div>
            </div>

            <div className="breadcrumb-row">
              <div className="container">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("Robotics_For_Good_Introduction_LinkHome")}</Link>
                  </li>
                  <li>{t("Robotics_For_Good_Introduction_Link")}</li>
                </ul>
              </div>
            </div>

            {year === "2025" && this.robotics2025Content()}
            {year === "2026" && this.robotics2026Content()}


          </div>
        </div>
      </>
    );
  }
}

export default RoboticsForGoodIntroduction = withTranslation()(RoboticsForGoodIntroduction);
